module.exports = __webpack_public_path__ + "static/media/tokenlistsgrouped.f424991d.png";